var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96967 2.96967C7.11032 2.82902 7.30109 2.75 7.5 2.75H10.5C10.6989 2.75 10.8897 2.82902 11.0303 2.96967C11.171 3.11032 11.25 3.30109 11.25 3.5V4.25H6.75V3.5C6.75 3.30109 6.82902 3.11032 6.96967 2.96967ZM5.25 4.25V3.5C5.25 2.90326 5.48705 2.33097 5.90901 1.90901C6.33097 1.48705 6.90326 1.25 7.5 1.25H10.5C11.0967 1.25 11.669 1.48705 12.091 1.90901C12.5129 2.33097 12.75 2.90326 12.75 3.5V4.25H14.25H15.75C16.1642 4.25 16.5 4.58579 16.5 5C16.5 5.41421 16.1642 5.75 15.75 5.75H15V15.5C15 16.0967 14.7629 16.669 14.341 17.091C13.919 17.5129 13.3467 17.75 12.75 17.75H5.25C4.65326 17.75 4.08097 17.5129 3.65901 17.091C3.23705 16.669 3 16.0967 3 15.5V5.75H2.25C1.83579 5.75 1.5 5.41421 1.5 5C1.5 4.58579 1.83579 4.25 2.25 4.25H3.75H5.25ZM6 5.75H12H13.5V15.5C13.5 15.6989 13.421 15.8897 13.2803 16.0303C13.1397 16.171 12.9489 16.25 12.75 16.25H5.25C5.05109 16.25 4.86032 16.171 4.71967 16.0303C4.57902 15.8897 4.5 15.6989 4.5 15.5V5.75H6ZM7.5 8C7.91421 8 8.25 8.33579 8.25 8.75V13.25C8.25 13.6642 7.91421 14 7.5 14C7.08579 14 6.75 13.6642 6.75 13.25V8.75C6.75 8.33579 7.08579 8 7.5 8ZM11.25 13.25V8.75C11.25 8.33579 10.9142 8 10.5 8C10.0858 8 9.75 8.33579 9.75 8.75V13.25C9.75 13.6642 10.0858 14 10.5 14C10.9142 14 11.25 13.6642 11.25 13.25Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBlack);
export default __webpack_public_path__ + "static/media/deleteIcon_black.ff46a528dbd1c9a5bae031342819086f.svg";
export { ForwardRef as ReactComponent };